import { Typography } from "@mui/material";
import { firstLetters } from "../../util/firstLetters";
import classnames from "classnames";

export const RideCategory = ({ category, className }) =>
    <Typography variant="label2" color="textSecondary" className={classnames(className,"ride-category")} component="div">
        {firstLetters(category)}
    </Typography>;
